import React from 'react';

export const OutageIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_413_2982)">
      <path
        d="M4.39349 25.6064C-1.46425 19.7487 -1.46425 10.2514 4.39349 4.39331C10.2512 -1.46444 19.7486 -1.46444 25.6066 4.39331C31.4644 10.2511 31.4644 19.7484 25.6066 25.6064C19.7486 31.4645 10.2512 31.4645 4.39349 25.6064Z"
        fill="#482764"
        fillOpacity="0.12"
      />
      <path
        d="M25.6063 25.6063C27.8956 23.317 29.286 20.4713 29.7858 17.5046L16.2281 3.94681C15.8887 3.6075 15.4441 3.43799 14.9999 3.43799C14.5553 3.43799 14.111 3.6075 13.7717 3.94681L3.94679 13.7717C3.26851 14.45 3.26851 15.5498 3.94679 16.2281L17.5049 29.7859C20.4712 29.2861 23.317 27.8956 25.6063 25.6063Z"
        fill="#482764"
        fillOpacity="0.15"
      />
      <path
        d="M16.2281 26.0529C15.5498 26.7312 14.45 26.7312 13.7716 26.0529L3.94673 16.228C3.26845 15.5497 3.26845 14.45 3.94673 13.7716L13.7716 3.9467C14.4499 3.26842 15.5497 3.26842 16.2281 3.9467L26.053 13.7716C26.7313 14.4499 26.7313 15.5497 26.053 16.228L16.2281 26.0529Z"
        fill="white"
      />
      <path
        d="M26.053 13.7717L16.2281 3.94681C15.8888 3.60779 15.4445 3.43799 14.9999 3.43799V26.5618C15.4445 26.5618 15.8888 26.3923 16.2281 26.053L26.053 16.2281C26.7313 15.5498 26.7313 14.4501 26.053 13.7717Z"
        fill="#CEEAF2"
      />
      <path
        d="M14.9998 25.6142C14.789 25.6142 14.5909 25.5322 14.4416 25.3832L4.61634 15.5583C4.30855 15.2505 4.30855 14.7498 4.61634 14.4419L14.4416 4.61672C14.591 4.46789 14.7887 4.38574 14.9998 4.38574C15.2107 4.38574 15.409 4.46766 15.5584 4.61707L25.3833 14.442C25.5327 14.5914 25.6147 14.7894 25.6147 15.0003C25.6147 15.2111 25.5327 15.4092 25.3833 15.5583L15.5584 25.3838C15.409 25.5322 15.2108 25.6142 14.9998 25.6142Z"
        fill="#E46A5D"
      />
      <path
        d="M25.3831 14.4415L15.5582 4.61658C15.4088 4.46717 15.2105 4.38525 14.9996 4.38525V25.614C15.2105 25.614 15.4088 25.5321 15.5582 25.383L25.3831 15.5575C25.5325 15.4088 25.6144 15.2104 25.6144 14.9995C25.6144 14.7886 25.5325 14.5909 25.3831 14.4415Z"
        fill="#D45446"
      />
      <path
        d="M14.9998 24.3783L5.62134 14.9998L14.9998 5.62158L24.378 14.9998L14.9998 24.3783ZM6.96113 14.9998L14.9999 23.0389L23.0387 14.9998L14.9998 6.96108L6.96113 14.9998Z"
        fill="#F1B14F"
      />
      <path
        d="M14.9982 24.3781L24.3763 15L24.3763 15L14.9982 24.3781L14.9982 24.3781Z"
        fill="#D34837"
      />
      <path
        d="M15.0001 5.62187V6.96138L23.0386 14.9998L15.0001 23.0386V24.3783L24.3781 14.9998L14.9998 5.62158L15.0001 5.62187Z"
        fill="#F0973E"
      />
      <path
        d="M16.0328 17.8343L17.0909 13.2513L14.2511 14.3468L15.0941 10.6953H13.9376L12.6917 16.0925L15.5315 14.9969L14.8763 17.8343H14.3015L14.9936 19.8314L16.6079 17.8343H16.0328Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_413_2982">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);